// This avoids using hooks for places where that is important and it allows
// easy mocking for tests.
//
// Don't return the whole location for this.  React allows reading the pathname
// directly from window.location like this, but modifying the location outside
// of useLocation() related hooks is not supported.
export const windowPathname = (): string => window.location.pathname;
